// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Public Model Hub — 2026 redesign. Token-driven; safe in both themes. */
.public-model-hub {
  padding: 1.25rem;
  max-width: 1440px;
  margin: 0 auto;
  /* ---------- Hero ---------- */
}
.public-model-hub .hub-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.5rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: radial-gradient(120% 140% at 100% 0%, var(--primary-soft) 0%, transparent 55%), var(--card);
  box-shadow: var(--shadow-sm);
}
.public-model-hub .hub-hero__title {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0;
  font-size: 1.65rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--foreground);
}
.public-model-hub .hub-hero__title i {
  color: var(--primary);
}
.public-model-hub .hub-hero__subtitle {
  margin: 0.35rem 0 0;
  color: var(--muted-foreground);
  font-size: 0.95rem;
}
.public-model-hub .hub-hero__count {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  background: var(--card-hover);
}
.public-model-hub .hub-hero__count-num {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
  color: var(--primary);
  font-family: var(--font-mono);
}
.public-model-hub .hub-hero__count-label {
  font-size: 0.75rem;
  color: var(--muted-foreground);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.public-model-hub {
  /* ---------- Toolbar ---------- */
}
.public-model-hub .hub-toolbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  margin-bottom: 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--card);
  box-shadow: var(--shadow-sm);
}
.public-model-hub .hub-toolbar__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.public-model-hub .hub-toolbar__search {
  position: relative;
  width: 100%;
}
.public-model-hub .hub-toolbar__search-icon {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted-foreground);
  font-size: 0.85rem;
  pointer-events: none;
}
.public-model-hub .hub-toolbar__search-input {
  width: 100%;
  padding: 0.55rem 2.2rem 0.55rem 2.2rem;
  font-size: 0.9rem;
  color: var(--foreground);
  background: var(--page-bg-subtle);
  border: 1px solid var(--input);
  border-radius: var(--radius-full);
  transition: border-color var(--transition), box-shadow var(--transition), background var(--transition);
}
.public-model-hub .hub-toolbar__search-input::placeholder {
  color: var(--muted-foreground);
}
.public-model-hub .hub-toolbar__search-input:focus {
  outline: none;
  background: var(--card);
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--ring);
}
.public-model-hub .hub-toolbar__search-clear {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius-full);
  background: var(--secondary);
  color: var(--muted-foreground);
  cursor: pointer;
  transition: background var(--transition), color var(--transition);
}
.public-model-hub .hub-toolbar__search-clear:hover {
  background: var(--secondary-hover);
  color: var(--foreground);
}
.public-model-hub .hub-toolbar__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.public-model-hub .hub-toolbar__controls {
  display: flex;
  gap: 0.5rem;
}
.public-model-hub .hub-toolbar__meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}
.public-model-hub .hub-toolbar__count {
  font-size: 0.8rem;
  color: var(--muted-foreground);
  font-family: var(--font-mono);
}
.public-model-hub .hub-toolbar__reset {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  color: var(--primary);
  background: var(--primary-soft);
  border: none;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background var(--transition);
}
.public-model-hub .hub-toolbar__reset:hover {
  background: var(--accent);
}
.public-model-hub {
  /* ---------- Type chips ---------- */
}
.public-model-hub .hub-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--muted-foreground);
  background: var(--page-bg-subtle);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition);
}
.public-model-hub .hub-chip i {
  font-size: 0.78rem;
}
.public-model-hub .hub-chip:hover {
  color: var(--foreground);
  border-color: var(--border-strong);
  background: var(--card-hover);
}
.public-model-hub .hub-chip--active {
  color: var(--primary-foreground);
  background: var(--primary);
  border-color: var(--primary);
}
.public-model-hub .hub-chip--active:hover {
  background: var(--primary-hover);
  color: var(--primary-foreground);
}
.public-model-hub {
  /* ---------- Toolbar dropdown ---------- */
}
.public-model-hub .hub-dropdown__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.8rem;
  font-size: 0.82rem;
  color: var(--foreground);
  background: var(--page-bg-subtle);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition);
}
.public-model-hub .hub-dropdown__btn:hover {
  border-color: var(--border-strong);
  background: var(--card-hover);
}
.public-model-hub .hub-dropdown__btn:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 1px;
}
.public-model-hub .hub-dropdown__btn.is-open {
  border-color: var(--primary);
  background: var(--card-hover);
}
.public-model-hub .hub-dropdown__btn.is-open .hub-dropdown__caret {
  transform: rotate(180deg);
}
.public-model-hub .hub-dropdown__btn {
  /* A narrowing filter is on — say so on the closed trigger. */
}
.public-model-hub .hub-dropdown__btn.is-filtered {
  color: var(--primary);
  border-color: var(--primary);
  background: var(--primary-soft);
}
.public-model-hub .hub-dropdown__btn.is-filtered i, .public-model-hub .hub-dropdown__btn.is-filtered .hub-dropdown__value {
  color: var(--primary);
}
.public-model-hub .hub-dropdown__btn .hub-dropdown__caret {
  font-size: 0.65rem;
  color: var(--muted-foreground);
  transition: transform var(--transition);
}
.public-model-hub .hub-dropdown__btn i {
  color: var(--muted-foreground);
}
.public-model-hub .hub-dropdown__btn .hub-dropdown__value {
  color: var(--foreground);
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.public-model-hub {
  /* ---------- Grid ---------- */
}
.public-model-hub .hub-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}
.public-model-hub {
  /* ---------- Card ---------- */
}
.public-model-hub .hub-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1.15rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition), box-shadow var(--transition), transform var(--transition);
}
.public-model-hub .hub-card:hover {
  background: var(--card-hover);
  border-color: var(--border-strong);
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}
.public-model-hub .hub-card:focus-visible {
  outline: none;
  box-shadow: var(--shadow-glow);
}
.public-model-hub .hub-card__top {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.public-model-hub .hub-card__title-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}
.public-model-hub .hub-card__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--foreground);
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.public-model-hub .hub-card__subrow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.public-model-hub .hub-card__updated {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.72rem;
  color: var(--muted-foreground);
}
.public-model-hub .hub-card__updated i {
  font-size: 0.66rem;
}
.public-model-hub .hub-card__open {
  position: absolute;
  top: 0.9rem;
  right: 0.9rem;
  color: var(--muted-foreground);
  font-size: 0.8rem;
  opacity: 0;
  transform: translate(2px, 2px);
  transition: opacity var(--transition), transform var(--transition), color var(--transition);
}
.public-model-hub .hub-card:hover .public-model-hub .hub-card__open, .public-model-hub .hub-card:focus-visible .public-model-hub .hub-card__open {
  opacity: 1;
  transform: translate(0, 0);
  color: var(--primary);
}
.public-model-hub .hub-card__detail {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.45;
  color: var(--muted-foreground);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.public-model-hub .hub-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border);
}
.public-model-hub .hub-card__owner {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
  padding: 0.15rem 0.4rem 0.15rem 0.15rem;
  margin-left: -0.15rem;
  background: none;
  border: 1px solid transparent;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition);
}
.public-model-hub .hub-card__owner:hover {
  background: var(--card-hover);
  border-color: var(--border);
}
.public-model-hub .hub-card__owner:hover .hub-card__owner-name {
  color: var(--primary);
}
.public-model-hub .hub-card__owner:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 1px;
}
.public-model-hub .hub-card__owner-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--foreground);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 11rem;
}
.public-model-hub .hub-card__meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: auto;
}
.public-model-hub .hub-card__download {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.85rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--primary-foreground);
  background: var(--primary);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: background var(--transition), box-shadow var(--transition);
}
.public-model-hub .hub-card__download:hover {
  background: var(--primary-hover);
  box-shadow: var(--shadow-glow);
}
.public-model-hub .hub-card__download:disabled {
  opacity: 0.65;
  cursor: default;
  box-shadow: none;
}
.public-model-hub .hub-card__untrained {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--warning);
}
.public-model-hub .hub-card__untrained i {
  font-size: 0.7rem;
}
.public-model-hub {
  /* Compact signal (downloads / versions) in the card meta line */
}
.public-model-hub .hub-signal {
  display: inline-flex;
  align-items: baseline;
  gap: 0.3rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--foreground);
}
.public-model-hub .hub-signal i {
  font-size: 0.72rem;
  opacity: 0.8;
  color: var(--muted-foreground);
  align-self: center;
}
.public-model-hub .hub-signal__unit {
  font-weight: 400;
  color: var(--muted-foreground);
}
.public-model-hub .hub-signal__sep {
  color: var(--muted-foreground);
  opacity: 0.6;
}
.public-model-hub {
  /* ---------- Results bar ---------- */
}
.public-model-hub .hub-results {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  padding: 0 0.15rem;
}
.public-model-hub .hub-results__count {
  font-size: 0.85rem;
  color: var(--muted-foreground);
}
.public-model-hub .hub-results__count strong {
  color: var(--foreground);
  font-weight: 600;
}
.public-model-hub .hub-results__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-left: auto;
}
.public-model-hub .hub-results__clear {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--primary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.2rem 0.35rem;
  border-radius: var(--radius-sm);
}
.public-model-hub .hub-results__clear:hover {
  text-decoration: underline;
}
.public-model-hub {
  /* Removable active-filter pill */
}
.public-model-hub .hub-fpill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.6rem;
  font-size: 0.76rem;
  font-weight: 500;
  color: var(--accent-foreground);
  background: var(--primary-soft);
  border: 1px solid transparent;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background var(--transition), color var(--transition);
}
.public-model-hub .hub-fpill i:last-child {
  font-size: 0.66rem;
  opacity: 0.75;
}
.public-model-hub .hub-fpill:hover {
  background: var(--accent);
}
.public-model-hub {
  /* ---------- Skeleton ---------- */
}
.public-model-hub .hub-card--skeleton {
  cursor: default;
}
.public-model-hub .hub-card--skeleton:hover {
  transform: none;
  box-shadow: var(--shadow-sm);
  background: var(--card);
  border-color: var(--border);
}
.public-model-hub .hub-skel {
  background: var(--muted);
  border-radius: var(--radius-sm);
  position: relative;
  overflow: hidden;
}
.public-model-hub .hub-skel::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, var(--card-hover), transparent);
  animation: hub-shimmer 1.4s infinite;
}
.public-model-hub .hub-skel--icon {
  width: 42px;
  height: 42px;
  border-radius: var(--radius);
}
.public-model-hub .hub-skel--line {
  height: 12px;
  width: 100%;
}
.public-model-hub .hub-skel--short {
  width: 60%;
}
.public-model-hub .hub-skel--title {
  height: 14px;
  width: 70%;
}
.public-model-hub .hub-skel--pill {
  height: 18px;
  width: 90px;
  border-radius: var(--radius-full);
}
.public-model-hub .hub-skel--chip {
  height: 12px;
  width: 64px;
}
@keyframes hub-shimmer {
  100% {
    transform: translateX(100%);
  }
}
.public-model-hub {
  /* ---------- Empty states ---------- */
}
.public-model-hub .hub-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 4rem 1.5rem;
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-xl);
  background: var(--card);
}
.public-model-hub .hub-empty__icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  border-radius: var(--radius-full);
  background: var(--primary-soft);
  color: var(--primary);
  font-size: 1.5rem;
}
.public-model-hub .hub-empty__title {
  margin: 0 0 0.35rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--foreground);
}
.public-model-hub .hub-empty__text {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: var(--muted-foreground);
  max-width: 380px;
}
.public-model-hub .hub-empty__action {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--foreground);
  background: var(--secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition);
}
.public-model-hub .hub-empty__action:hover {
  background: var(--secondary-hover);
  border-color: var(--border-strong);
}

/* ---------- Shared bits used in BOTH grid + portalled drawer (must be global) ---------- */
.hub-card__icon {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius);
  color: #fff;
  font-size: 1.05rem;
  background: linear-gradient(135deg, var(--brand-500), var(--brand-700));
  box-shadow: 0 6px 14px -4px rgba(16, 185, 129, 0.5);
}
.hub-card__icon--bounding_box {
  background: linear-gradient(135deg, #38bdf8, #0369a1);
  box-shadow: 0 6px 14px -4px rgba(56, 189, 248, 0.5);
}
.hub-card__icon--segmentation {
  background: linear-gradient(135deg, #a78bfa, #6d28d9);
  box-shadow: 0 6px 14px -4px rgba(167, 139, 250, 0.5);
}

.hub-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

/* Owner avatar (initials) — used in card footer + drawer facts */
.hub-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}
.hub-avatar--sm {
  width: 22px;
  height: 22px;
  font-size: 0.62rem;
}

/* Neutral tag pill — kept quiet so the primary (emerald) actions lead the hierarchy */
.hub-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  font-size: 0.72rem;
  font-weight: 500;
  color: var(--muted-foreground);
  background: var(--secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  transition: color var(--transition), background var(--transition);
}
.hub-tag--more {
  opacity: 0.75;
}

/* Task-type pill — icon + text share one hue per type for instant, coherent color-coding */
.hub-type-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.18rem 0.6rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  border-radius: var(--radius-full);
  border: 1px solid transparent;
  white-space: nowrap;
}
.hub-type-pill i {
  font-size: 0.68rem;
}
.hub-type-pill {
  /* classification → emerald */
}
.hub-type-pill--classification {
  color: var(--brand-600);
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.28);
}
.hub-type-pill {
  /* detection → sky blue */
}
.hub-type-pill--bounding_box {
  color: #0284c7;
  background: rgba(56, 189, 248, 0.14);
  border-color: rgba(56, 189, 248, 0.3);
}
.hub-type-pill {
  /* segmentation → violet */
}
.hub-type-pill--segmentation {
  color: #7c3aed;
  background: rgba(167, 139, 250, 0.16);
  border-color: rgba(167, 139, 250, 0.32);
}

html.dark .hub-type-pill--classification {
  color: var(--brand-300);
}

html.dark .hub-type-pill--bounding_box {
  color: #7dd3fc;
}

html.dark .hub-type-pill--segmentation {
  color: #c4b5fd;
}

/* ---------- Drawer (portalled to body — outside .public-model-hub) ---------- */
.hub-drawer-overlay {
  position: fixed;
  inset: 0;
  z-index: 1080;
  background: var(--overlay);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: flex-end;
  animation: hub-fade 0.18s ease-out;
}

.hub-drawer {
  width: min(480px, 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--card);
  border-left: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  animation: hub-slide-in 0.24s cubic-bezier(0.4, 0, 0.2, 1);
}
.hub-drawer__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.15rem 1.25rem;
  border-bottom: 1px solid var(--border);
}
.hub-drawer__heading {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}
.hub-drawer__subrow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.hub-drawer__title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--foreground);
  letter-spacing: -0.01em;
  word-break: break-word;
}
.hub-drawer__primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  margin: 1.1rem 0 0.25rem;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--primary-foreground);
  background: var(--primary);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: background var(--transition), box-shadow var(--transition);
}
.hub-drawer__primary:hover {
  background: var(--primary-hover);
  box-shadow: var(--shadow-glow);
}
.hub-drawer__primary:disabled {
  opacity: 0.65;
  cursor: default;
  box-shadow: none;
}
.hub-drawer__close {
  margin-left: auto;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  background: transparent;
  color: var(--muted-foreground);
  cursor: pointer;
  transition: background var(--transition), color var(--transition);
}
.hub-drawer__close:hover {
  background: var(--secondary);
  color: var(--foreground);
}
.hub-drawer__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem;
}
.hub-drawer__detail {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  line-height: 1.55;
  color: var(--muted-foreground);
}
.hub-drawer__facts {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  margin: 1rem 0 1.5rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--page-bg-subtle);
}
.hub-drawer__section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted-foreground);
}
.hub-drawer__section-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.35rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--muted-foreground);
  background: var(--secondary);
  border-radius: var(--radius-full);
  letter-spacing: 0;
}
.hub-drawer__empty {
  color: var(--muted-foreground);
  font-size: 0.9rem;
}

.hub-metric {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
  font-size: 0.85rem;
}
.hub-metric + .hub-metric {
  border-top: 1px solid var(--border);
}
.hub-metric__label {
  color: var(--muted-foreground);
  flex-shrink: 0;
}
.hub-metric__value {
  color: var(--foreground);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.hub-owner-val {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.hub-id-val {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
}
.hub-id-val code {
  overflow: hidden;
  text-overflow: ellipsis;
}

.hub-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--secondary);
  color: var(--muted-foreground);
  cursor: pointer;
  font-size: 0.72rem;
  transition: background var(--transition), color var(--transition);
}
.hub-copy-btn:hover {
  background: var(--secondary-hover);
  color: var(--foreground);
}

.hub-mono {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--foreground);
}

.hub-version-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.hub-version {
  padding: 0.85rem 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--card-hover);
}
.hub-version__head {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}
.hub-version__name {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--foreground);
}
.hub-version__name i {
  color: var(--muted-foreground);
  font-size: 0.8rem;
}
.hub-version__download {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-left: auto;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--primary-foreground);
  background: var(--primary);
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: background var(--transition);
}
.hub-version__download:hover {
  background: var(--primary-hover);
}
.hub-version__download:disabled {
  opacity: 0.65;
  cursor: default;
}
.hub-version__classes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.65rem;
}
.hub-version__metrics {
  margin-top: 0.65rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border);
}

.hub-class-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  font-size: 0.75rem;
  color: var(--foreground);
  background: var(--secondary);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
}
.hub-class-chip__dot {
  width: 9px;
  height: 9px;
  border-radius: var(--radius-full);
  background: var(--muted-foreground);
  flex-shrink: 0;
}

/* ---------- Toolbar dropdown menu ----------
   Portalled to <body>, so these rules live at the top level on purpose —
   nesting them under .public-model-hub would mean they never match. */
.hub-dropdown-portal {
  /* A long owner display name would otherwise stretch the menu to its width;
     cap it and let the label ellipsis instead. min-width (set inline from the
     trigger) still wins, so a narrow trigger is unaffected. */
  max-width: min(360px, 100vw - 20px);
}
.hub-dropdown-portal .hub-dropdown__menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.hub-dropdown-portal .hub-dropdown__search {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 0.65rem;
  border-bottom: 1px solid var(--border);
  background: var(--page-bg-subtle);
}
.hub-dropdown-portal .hub-dropdown__search i {
  font-size: 0.75rem;
  color: var(--muted-foreground);
  flex-shrink: 0;
}
.hub-dropdown-portal .hub-dropdown__search input {
  flex: 1 1;
  min-width: 0;
  font-size: 0.82rem;
  color: var(--foreground);
  background: transparent;
  border: none;
  outline: none;
}
.hub-dropdown-portal .hub-dropdown__search input::placeholder {
  color: var(--muted-foreground);
}
.hub-dropdown-portal {
  /* The scroll container. Its own scroll must not close the menu — see HubDropdown. */
}
.hub-dropdown-portal .hub-dropdown__list {
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0.3rem 0;
  outline: none;
}
.hub-dropdown-portal .hub-dropdown__item {
  gap: 0.5rem;
  padding: 0.45rem 0.7rem;
}
.hub-dropdown-portal .hub-dropdown__item.is-focused {
  background: var(--muted);
}
.hub-dropdown-portal .hub-dropdown__item.is-active {
  color: var(--primary);
  font-weight: 600;
}
.hub-dropdown-portal .hub-dropdown__tick {
  width: 1rem;
  flex-shrink: 0;
  font-size: 0.72rem;
  opacity: 0;
}
.hub-dropdown-portal .hub-dropdown__tick.is-on {
  opacity: 1;
  color: var(--primary);
}
.hub-dropdown-portal .hub-dropdown__dot {
  width: 9px;
  height: 9px;
  flex-shrink: 0;
  border-radius: var(--radius-full);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
}
.hub-dropdown-portal .hub-dropdown__item-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hub-dropdown-portal .hub-dropdown__count {
  flex-shrink: 0;
  padding: 0.05rem 0.4rem;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--muted-foreground);
  background: var(--secondary);
  border-radius: var(--radius-full);
}
.hub-dropdown-portal .hub-dropdown__none {
  margin: 0;
  padding: 0.85rem 0.7rem;
  font-size: 0.8rem;
  text-align: center;
  color: var(--muted-foreground);
}

/* Selected item in the toolbar dropdown */
.labelflow-dropdown-item.is-active {
  color: var(--primary);
  font-weight: 600;
}

@keyframes hub-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes hub-slide-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@media (max-width: 640px) {
  .public-model-hub {
    padding: 0.85rem;
  }
  .public-model-hub .hub-toolbar {
    position: static;
  }
  .public-model-hub .hub-toolbar__meta {
    margin-left: 0;
    width: 100%;
  }
  .hub-drawer {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/management/modelHub/PublicModelHub.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,yEAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EAEA,+BAAA;AAAF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,+BAAA;EACA,uGACE;EAEF,4BAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AADN;AAGM;EAAI,qBAAA;AAAV;AAGI;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;AADN;AAII;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;AAFN;AAII;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;AAFN;AAII;EACE,kBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAFN;AA1DA;EAgEE,kCAAA;AAHF;AAIE;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,+BAAA;EACA,uBAAA;EACA,4BAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;AAFN;AAKI;EACE,kBAAA;EACA,WAAA;AAHN;AAKI;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,oBAAA;AAHN;AAKI;EACE,WAAA;EACA,sCAAA;EACA,iBAAA;EACA,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,iCAAA;EACA,sGAAA;AAHN;AAKM;EAAiB,8BAAA;AAFvB;AAGM;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,iCAAA;AADR;AAII;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iCAAA;EACA,4BAAA;EACA,8BAAA;EACA,eAAA;EACA,iEAAA;AAFN;AAGM;EAAU,kCAAA;EAAoC,wBAAA;AACpD;AAEI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAAN;AAGI;EACE,aAAA;EACA,WAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAFN;AAII;EACE,iBAAA;EACA,8BAAA;EACA,6BAAA;AAFN;AAII;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,+BAAA;EACA,YAAA;EACA,iCAAA;EACA,eAAA;EACA,wCAAA;AAFN;AAGM;EAAU,yBAAA;AAAhB;AA3KA;EA+KE,qCAAA;AADF;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;EACA,+BAAA;EACA,iCAAA;EACA,eAAA;EACA,iCAAA;AAAJ;AAEI;EAAI,kBAAA;AACR;AACI;EACE,wBAAA;EACA,kCAAA;EACA,6BAAA;AACN;AACI;EACE,gCAAA;EACA,0BAAA;EACA,4BAAA;AACN;AAAM;EAAU,gCAAA;EAAkC,gCAAA;AAIlD;AA7MA;EA6ME,2CAAA;AAGF;AAFE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,iCAAA;EACA,+BAAA;EACA,iCAAA;EACA,eAAA;EACA,iCAAA;AAIJ;AAFI;EAAU,kCAAA;EAAoC,6BAAA;AAMlD;AALI;EAAkB,iCAAA;EAAmC,mBAAA;AASzD;AARI;EACE,4BAAA;EACA,6BAAA;AAUN;AATM;EAAuB,yBAAA;AAY7B;AA9BE;EAoBE,6DAAA;AAaJ;AAZI;EACE,qBAAA;EACA,4BAAA;EACA,+BAAA;AAcN;AAbM;EAA0B,qBAAA;AAgBhC;AAdI;EACE,kBAAA;EACA,8BAAA;EACA,uCAAA;AAgBN;AAdI;EAAI,8BAAA;AAiBR;AAhBI;EACE,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkBN;AAtQA;EAwPE,+BAAA;AAiBF;AAhBE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAkBJ;AA9QA;EA+PE,+BAAA;AAkBF;AAjBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EACA,4BAAA;EACA,eAAA;EACA,mIAAA;AAmBJ;AAhBI;EACE,6BAAA;EACA,kCAAA;EACA,4BAAA;EACA,2BAAA;AAkBN;AAhBI;EACE,aAAA;EACA,8BAAA;AAkBN;AAfI;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAiBN;AAdI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAgBN;AAdI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAgBN;AAbI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAeN;AAbI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAeN;AAdM;EAAI,kBAAA;AAiBV;AAdI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,UAAA;EACA,8BAAA;EACA,2FAAA;AAgBN;AAdI;EAEE,UAAA;EACA,0BAAA;EACA,qBAAA;AAeN;AAZI;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAcN;AAXI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;AAaN;AAXI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,wEAAA;AAaN;AAXM;EACE,6BAAA;EACA,2BAAA;AAaR;AAZQ;EAAwB,qBAAA;AAehC;AAbM;EACE,iCAAA;EACA,mBAAA;AAeR;AAZI;EACE,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAcN;AAZI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAcN;AAZI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,sEAAA;AAcN;AAbM;EAAU,gCAAA;EAAkC,8BAAA;AAiBlD;AAhBM;EAAa,aAAA;EAAe,eAAA;EAAiB,gBAAA;AAqBnD;AAnBI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AAqBN;AApBM;EAAI,iBAAA;AAuBV;AAxbA;EAqaE,gEAAA;AAsBF;AArBE;EACE,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AAuBJ;AAtBI;EAAI,kBAAA;EAAoB,YAAA;EAAc,8BAAA;EAAgC,kBAAA;AA4B1E;AA3BI;EAAU,gBAAA;EAAkB,8BAAA;AA+BhC;AA9BI;EAAS,8BAAA;EAAgC,YAAA;AAkC7C;AAjdA;EAkbE,sCAAA;AAkCF;AAjCE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAmCJ;AAjCI;EACE,kBAAA;EACA,8BAAA;AAmCN;AAlCM;EAAS,wBAAA;EAA0B,gBAAA;AAsCzC;AApCI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAsCN;AApCI;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,+BAAA;AAsCN;AArCM;EAAU,0BAAA;AAwChB;AAxfA;EAodE,iCAAA;AAuCF;AAtCE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,iEAAA;AAwCJ;AAvCI;EAAe,kBAAA;EAAoB,aAAA;AA2CvC;AA1CI;EAAU,yBAAA;AA6Cd;AAhhBA;EAseE,mCAAA;AA6CF;AA5CE;EACE,eAAA;AA8CJ;AA7CI;EAAU,eAAA;EAAiB,4BAAA;EAA8B,uBAAA;EAAyB,2BAAA;AAmDtF;AAjDE;EACE,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAmDJ;AAlDI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,4BAAA;EACA,+EAAA;EACA,oCAAA;AAoDN;AAlDI;EAAU,WAAA;EAAa,YAAA;EAAc,4BAAA;AAuDzC;AAtDI;EAAU,YAAA;EAAc,WAAA;AA0D5B;AAzDI;EAAW,UAAA;AA4Df;AA3DI;EAAW,YAAA;EAAc,UAAA;AA+D7B;AA9DI;EAAU,YAAA;EAAc,WAAA;EAAa,iCAAA;AAmEzC;AAlEI;EAAU,YAAA;EAAc,WAAA;AAsE5B;AApEE;EACE;IAAO,2BAAA;EAuET;AACF;AAxkBA;EAmgBE,uCAAA;AAwEF;AAvEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uCAAA;EACA,+BAAA;EACA,uBAAA;AAyEJ;AAvEI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AAyEN;AAvEI;EAAW,mBAAA;EAAqB,iBAAA;EAAmB,gBAAA;EAAkB,wBAAA;AA6EzE;AA5EI;EAAU,gBAAA;EAAkB,iBAAA;EAAmB,8BAAA;EAAgC,gBAAA;AAkFnF;AAjFI;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;EACA,eAAA;EACA,wEAAA;AAmFN;AAlFM;EAAU,kCAAA;EAAoC,kCAAA;AAsFpD;;AAjFA,4FAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,uEAAA;EACA,mDAAA;AAoFF;AAlFE;EACE,qDAAA;EACA,mDAAA;AAoFJ;AAlFE;EACE,qDAAA;EACA,oDAAA;AAoFJ;;AAhFA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAmFF;;AAhFA,iEAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qDAAA;AAmFF;AAlFE;EAAQ,WAAA;EAAa,YAAA;EAAc,kBAAA;AAuFrC;;AApFA,sFAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;EACA,iCAAA;EACA,iEAAA;AAuFF;AAtFE;EAAU,aAAA;AAyFZ;;AAtFA,2FAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iCAAA;EACA,6BAAA;EACA,mBAAA;AAyFF;AAvFE;EAAI,kBAAA;AA0FN;AAtGA;EAcE,6BAAA;AA2FF;AA1FE;EACE,uBAAA;EACA,oCAAA;EACA,sCAAA;AA4FJ;AA9GA;EAoBE,yBAAA;AA6FF;AA5FE;EACE,cAAA;EACA,oCAAA;EACA,qCAAA;AA8FJ;AAtHA;EA0BE,0BAAA;AA+FF;AA9FE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AAgGJ;;AA7FA;EAA2C,uBAAA;AAiG3C;;AAhGA;EAAyC,cAAA;AAoGzC;;AAnGA;EAAyC,cAAA;AAuGzC;;AArGA,iFAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,0BAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,kCAAA;AAwGF;;AArGA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,4BAAA;EACA,0DAAA;AAwGF;AAtGE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,sCAAA;AAwGJ;AAtGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAwGJ;AAtGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAwGJ;AAtGE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;AAwGJ;AAtGE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,sEAAA;AAwGJ;AAvGI;EAAU,gCAAA;EAAkC,8BAAA;AA2GhD;AA1GI;EAAa,aAAA;EAAe,eAAA;EAAiB,gBAAA;AA+GjD;AA7GE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iCAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,iEAAA;AA+GJ;AA9GI;EAAU,4BAAA;EAA8B,wBAAA;AAkH5C;AA/GE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AAiHJ;AA/GE;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AAiHJ;AA9GE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iCAAA;AAgHJ;AA7GE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AA+GJ;AA7GE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,4BAAA;EACA,iCAAA;EACA,iBAAA;AA+GJ;AA7GE;EAAW,8BAAA;EAAgC,iBAAA;AAiH7C;;AA9GA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AAiHF;AAhHE;EAAQ,mCAAA;AAmHV;AAlHE;EAAW,8BAAA;EAAgC,cAAA;AAsH7C;AArHE;EAAW,wBAAA;EAA0B,gBAAA;EAAkB,iBAAA;EAAmB,sBAAA;AA2H5E;;AAzHA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AA4HF;;AA1HA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA6HF;AA5HE;EAAO,gBAAA;EAAkB,uBAAA;AAgI3B;;AA9HA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;EACA,+BAAA;EACA,4BAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,iEAAA;AAiIF;AAhIE;EAAU,kCAAA;EAAoC,wBAAA;AAoIhD;;AAjIA;EACE,6BAAA;EACA,kBAAA;EACA,wBAAA;AAoIF;;AAjIA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAoIF;;AAlIA;EACE,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;AAqIF;AAnIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAqIJ;AAnIE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAqIJ;AApII;EAAI,8BAAA;EAAgC,iBAAA;AAwIxC;AAtIE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,wCAAA;AAwIJ;AAvII;EAAU,gCAAA;AA0Id;AAzII;EAAa,aAAA;EAAe,eAAA;AA6IhC;AA1IE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AA4IJ;AA1IE;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;AA4IJ;;AAxIA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+BAAA;EACA,iCAAA;AA2IF;AAzIE;EACE,UAAA;EACA,WAAA;EACA,iCAAA;EACA,mCAAA;EACA,cAAA;AA2IJ;;AAvIA;;sEAAA;AAGA;EACE;;8DAAA;EAGA,mCAAA;AA0IF;AAxIE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AA0IJ;AAvIE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;EACA,iCAAA;AAyIJ;AAvII;EAAI,kBAAA;EAAoB,8BAAA;EAAgC,cAAA;AA4I5D;AA1II;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AA4IN;AA3IM;EAAiB,8BAAA;AA8IvB;AA7KA;EAmCE,oFAAA;AA6IF;AA5IE;EACE,gBAAA;EACA,4BAAA;EACA,iBAAA;EACA,aAAA;AA8IJ;AA3IE;EACE,WAAA;EACA,uBAAA;AA6IJ;AA3II;EAAe,wBAAA;AA8InB;AA7II;EAAc,qBAAA;EAAuB,gBAAA;AAiJzC;AA9IE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAgJJ;AA/II;EAAU,UAAA;EAAY,qBAAA;AAmJ1B;AAhJE;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;EACA,qDAAA;AAkJJ;AA/IE;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiJJ;AA9IE;EACE,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,4BAAA;EACA,iCAAA;AAgJJ;AA7IE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;AA+IJ;;AA3IA,0CAAA;AACA;EACE,qBAAA;EACA,gBAAA;AA8IF;;AA3IA;EACE;IAAO,UAAA;EA+IP;EA9IA;IAAK,UAAA;EAiJL;AACF;AAhJA;EACE;IAAO,2BAAA;EAmJP;EAlJA;IAAK,wBAAA;EAqJL;AACF;AAnJA;EACE;IACE,gBAAA;EAqJF;EApJE;IAAe,gBAAA;EAuJjB;EAtJE;IAAqB,cAAA;IAAgB,WAAA;EA0JvC;EAxJA;IAAc,WAAA;EA2Jd;AACF","sourcesContent":["/* Public Model Hub — 2026 redesign. Token-driven; safe in both themes. */\n\n.public-model-hub {\n  padding: 1.25rem;\n  max-width: 1440px;\n  margin: 0 auto;\n\n  /* ---------- Hero ---------- */\n  .hub-hero {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1rem;\n    padding: 1.5rem 1.5rem;\n    margin-bottom: 1rem;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-xl);\n    background:\n      radial-gradient(120% 140% at 100% 0%, var(--primary-soft) 0%, transparent 55%),\n      var(--card);\n    box-shadow: var(--shadow-sm);\n\n    &__title {\n      display: flex;\n      align-items: center;\n      gap: 0.65rem;\n      margin: 0;\n      font-size: 1.65rem;\n      font-weight: 600;\n      letter-spacing: -0.02em;\n      color: var(--foreground);\n\n      i { color: var(--primary); }\n    }\n\n    &__subtitle {\n      margin: 0.35rem 0 0;\n      color: var(--muted-foreground);\n      font-size: 0.95rem;\n    }\n\n    &__count {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      padding: 0.5rem 1rem;\n      border-radius: var(--radius-lg);\n      border: 1px solid var(--border);\n      background: var(--card-hover);\n    }\n    &__count-num {\n      font-size: 1.6rem;\n      font-weight: 700;\n      line-height: 1;\n      color: var(--primary);\n      font-family: var(--font-mono);\n    }\n    &__count-label {\n      font-size: 0.75rem;\n      color: var(--muted-foreground);\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n  }\n\n  /* ---------- Toolbar ---------- */\n  .hub-toolbar {\n    position: sticky;\n    top: 0;\n    z-index: 20;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 0.85rem 1rem;\n    margin-bottom: 0.75rem;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    background: var(--card);\n    box-shadow: var(--shadow-sm);\n\n    &__row {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      gap: 0.75rem;\n    }\n\n    &__search {\n      position: relative;\n      width: 100%;\n    }\n    &__search-icon {\n      position: absolute;\n      left: 0.85rem;\n      top: 50%;\n      transform: translateY(-50%);\n      color: var(--muted-foreground);\n      font-size: 0.85rem;\n      pointer-events: none;\n    }\n    &__search-input {\n      width: 100%;\n      padding: 0.55rem 2.2rem 0.55rem 2.2rem;\n      font-size: 0.9rem;\n      color: var(--foreground);\n      background: var(--page-bg-subtle);\n      border: 1px solid var(--input);\n      border-radius: var(--radius-full);\n      transition: border-color var(--transition), box-shadow var(--transition), background var(--transition);\n\n      &::placeholder { color: var(--muted-foreground); }\n      &:focus {\n        outline: none;\n        background: var(--card);\n        border-color: var(--primary);\n        box-shadow: 0 0 0 3px var(--ring);\n      }\n    }\n    &__search-clear {\n      position: absolute;\n      right: 0.6rem;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 22px;\n      height: 22px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      border: none;\n      border-radius: var(--radius-full);\n      background: var(--secondary);\n      color: var(--muted-foreground);\n      cursor: pointer;\n      transition: background var(--transition), color var(--transition);\n      &:hover { background: var(--secondary-hover); color: var(--foreground); }\n    }\n\n    &__chips {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.4rem;\n    }\n\n    &__controls {\n      display: flex;\n      gap: 0.5rem;\n    }\n\n    &__meta {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      margin-left: auto;\n    }\n    &__count {\n      font-size: 0.8rem;\n      color: var(--muted-foreground);\n      font-family: var(--font-mono);\n    }\n    &__reset {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.35rem;\n      padding: 0.3rem 0.6rem;\n      font-size: 0.8rem;\n      color: var(--primary);\n      background: var(--primary-soft);\n      border: none;\n      border-radius: var(--radius-full);\n      cursor: pointer;\n      transition: background var(--transition);\n      &:hover { background: var(--accent); }\n    }\n  }\n\n  /* ---------- Type chips ---------- */\n  .hub-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.4rem 0.85rem;\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: var(--muted-foreground);\n    background: var(--page-bg-subtle);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-full);\n    cursor: pointer;\n    transition: all var(--transition);\n\n    i { font-size: 0.78rem; }\n\n    &:hover {\n      color: var(--foreground);\n      border-color: var(--border-strong);\n      background: var(--card-hover);\n    }\n    &--active {\n      color: var(--primary-foreground);\n      background: var(--primary);\n      border-color: var(--primary);\n      &:hover { background: var(--primary-hover); color: var(--primary-foreground); }\n    }\n  }\n\n  /* ---------- Toolbar dropdown ---------- */\n  .hub-dropdown__btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.45rem;\n    padding: 0.45rem 0.8rem;\n    font-size: 0.82rem;\n    color: var(--foreground);\n    background: var(--page-bg-subtle);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-full);\n    cursor: pointer;\n    transition: all var(--transition);\n\n    &:hover { border-color: var(--border-strong); background: var(--card-hover); }\n    &:focus-visible { outline: 2px solid var(--primary); outline-offset: 1px; }\n    &.is-open {\n      border-color: var(--primary);\n      background: var(--card-hover);\n      .hub-dropdown__caret { transform: rotate(180deg); }\n    }\n    /* A narrowing filter is on — say so on the closed trigger. */\n    &.is-filtered {\n      color: var(--primary);\n      border-color: var(--primary);\n      background: var(--primary-soft);\n      i, .hub-dropdown__value { color: var(--primary); }\n    }\n    .hub-dropdown__caret {\n      font-size: 0.65rem;\n      color: var(--muted-foreground);\n      transition: transform var(--transition);\n    }\n    i { color: var(--muted-foreground); }\n    .hub-dropdown__value {\n      color: var(--foreground);\n      max-width: 12rem;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  /* ---------- Grid ---------- */\n  .hub-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1rem;\n  }\n\n  /* ---------- Card ---------- */\n  .hub-card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 0.7rem;\n    padding: 1.15rem;\n    background: var(--card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    cursor: pointer;\n    transition: background var(--transition), border-color var(--transition),\n      box-shadow var(--transition), transform var(--transition);\n\n    &:hover {\n      background: var(--card-hover);\n      border-color: var(--border-strong);\n      box-shadow: var(--shadow-md);\n      transform: translateY(-2px);\n    }\n    &:focus-visible {\n      outline: none;\n      box-shadow: var(--shadow-glow);\n    }\n\n    &__top {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.75rem;\n    }\n\n    &__title-wrap {\n      display: flex;\n      flex-direction: column;\n      gap: 0.35rem;\n      min-width: 0;\n    }\n    &__title {\n      margin: 0;\n      font-size: 1rem;\n      font-weight: 600;\n      color: var(--foreground);\n      letter-spacing: -0.01em;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &__subrow {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n    }\n    &__updated {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.3rem;\n      font-size: 0.72rem;\n      color: var(--muted-foreground);\n      i { font-size: 0.66rem; }\n    }\n\n    &__open {\n      position: absolute;\n      top: 0.9rem;\n      right: 0.9rem;\n      color: var(--muted-foreground);\n      font-size: 0.8rem;\n      opacity: 0;\n      transform: translate(2px, 2px);\n      transition: opacity var(--transition), transform var(--transition), color var(--transition);\n    }\n    &:hover &__open,\n    &:focus-visible &__open {\n      opacity: 1;\n      transform: translate(0, 0);\n      color: var(--primary);\n    }\n\n    &__detail {\n      margin: 0;\n      font-size: 0.85rem;\n      line-height: 1.45;\n      color: var(--muted-foreground);\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n\n    &__footer {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.5rem;\n      padding-top: 0.75rem;\n      border-top: 1px solid var(--border);\n    }\n    &__owner {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.45rem;\n      min-width: 0;\n      padding: 0.15rem 0.4rem 0.15rem 0.15rem;\n      margin-left: -0.15rem;\n      background: none;\n      border: 1px solid transparent;\n      border-radius: var(--radius-full);\n      cursor: pointer;\n      transition: background var(--transition), border-color var(--transition);\n\n      &:hover {\n        background: var(--card-hover);\n        border-color: var(--border);\n        .hub-card__owner-name { color: var(--primary); }\n      }\n      &:focus-visible {\n        outline: 2px solid var(--primary);\n        outline-offset: 1px;\n      }\n    }\n    &__owner-name {\n      font-size: 0.8rem;\n      font-weight: 500;\n      color: var(--foreground);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      max-width: 11rem;\n    }\n    &__meta {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 0.5rem;\n      margin-top: auto;\n    }\n    &__download {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.4rem;\n      padding: 0.4rem 0.85rem;\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: var(--primary-foreground);\n      background: var(--primary);\n      border: none;\n      border-radius: var(--radius);\n      cursor: pointer;\n      transition: background var(--transition), box-shadow var(--transition);\n      &:hover { background: var(--primary-hover); box-shadow: var(--shadow-glow); }\n      &:disabled { opacity: 0.65; cursor: default; box-shadow: none; }\n    }\n    &__untrained {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.35rem;\n      font-size: 0.75rem;\n      font-weight: 500;\n      color: var(--warning);\n      i { font-size: 0.7rem; }\n    }\n  }\n\n  /* Compact signal (downloads / versions) in the card meta line */\n  .hub-signal {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 0.3rem;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--foreground);\n    i { font-size: 0.72rem; opacity: 0.8; color: var(--muted-foreground); align-self: center; }\n    &__unit { font-weight: 400; color: var(--muted-foreground); }\n    &__sep { color: var(--muted-foreground); opacity: 0.6; }\n  }\n\n  /* ---------- Results bar ---------- */\n  .hub-results {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem 0.75rem;\n    margin-bottom: 1rem;\n    padding: 0 0.15rem;\n\n    &__count {\n      font-size: 0.85rem;\n      color: var(--muted-foreground);\n      strong { color: var(--foreground); font-weight: 600; }\n    }\n    &__filters {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 0.4rem;\n      margin-left: auto;\n    }\n    &__clear {\n      font-size: 0.8rem;\n      font-weight: 500;\n      color: var(--primary);\n      background: none;\n      border: none;\n      cursor: pointer;\n      padding: 0.2rem 0.35rem;\n      border-radius: var(--radius-sm);\n      &:hover { text-decoration: underline; }\n    }\n  }\n\n  /* Removable active-filter pill */\n  .hub-fpill {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.25rem 0.6rem;\n    font-size: 0.76rem;\n    font-weight: 500;\n    color: var(--accent-foreground);\n    background: var(--primary-soft);\n    border: 1px solid transparent;\n    border-radius: var(--radius-full);\n    cursor: pointer;\n    transition: background var(--transition), color var(--transition);\n    i:last-child { font-size: 0.66rem; opacity: 0.75; }\n    &:hover { background: var(--accent); }\n  }\n\n  /* ---------- Skeleton ---------- */\n  .hub-card--skeleton {\n    cursor: default;\n    &:hover { transform: none; box-shadow: var(--shadow-sm); background: var(--card); border-color: var(--border); }\n  }\n  .hub-skel {\n    background: var(--muted);\n    border-radius: var(--radius-sm);\n    position: relative;\n    overflow: hidden;\n    &::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n      transform: translateX(-100%);\n      background: linear-gradient(90deg, transparent, var(--card-hover), transparent);\n      animation: hub-shimmer 1.4s infinite;\n    }\n    &--icon { width: 42px; height: 42px; border-radius: var(--radius); }\n    &--line { height: 12px; width: 100%; }\n    &--short { width: 60%; }\n    &--title { height: 14px; width: 70%; }\n    &--pill { height: 18px; width: 90px; border-radius: var(--radius-full); }\n    &--chip { height: 12px; width: 64px; }\n  }\n  @keyframes hub-shimmer {\n    100% { transform: translateX(100%); }\n  }\n\n  /* ---------- Empty states ---------- */\n  .hub-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 4rem 1.5rem;\n    border: 1px dashed var(--border-strong);\n    border-radius: var(--radius-xl);\n    background: var(--card);\n\n    &__icon {\n      width: 64px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 1rem;\n      border-radius: var(--radius-full);\n      background: var(--primary-soft);\n      color: var(--primary);\n      font-size: 1.5rem;\n    }\n    &__title { margin: 0 0 0.35rem; font-size: 1.1rem; font-weight: 600; color: var(--foreground); }\n    &__text { margin: 0 0 1rem; font-size: 0.9rem; color: var(--muted-foreground); max-width: 380px; }\n    &__action {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.4rem;\n      padding: 0.5rem 1rem;\n      font-size: 0.85rem;\n      font-weight: 500;\n      color: var(--foreground);\n      background: var(--secondary);\n      border: 1px solid var(--border);\n      border-radius: var(--radius);\n      cursor: pointer;\n      transition: background var(--transition), border-color var(--transition);\n      &:hover { background: var(--secondary-hover); border-color: var(--border-strong); }\n    }\n  }\n}\n\n/* ---------- Shared bits used in BOTH grid + portalled drawer (must be global) ---------- */\n.hub-card__icon {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius);\n  color: #fff;\n  font-size: 1.05rem;\n  background: linear-gradient(135deg, var(--brand-500), var(--brand-700));\n  box-shadow: 0 6px 14px -4px rgba(16, 185, 129, 0.5);\n\n  &--bounding_box {\n    background: linear-gradient(135deg, #38bdf8, #0369a1);\n    box-shadow: 0 6px 14px -4px rgba(56, 189, 248, 0.5);\n  }\n  &--segmentation {\n    background: linear-gradient(135deg, #a78bfa, #6d28d9);\n    box-shadow: 0 6px 14px -4px rgba(167, 139, 250, 0.5);\n  }\n}\n\n.hub-card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n/* Owner avatar (initials) — used in card footer + drawer facts */\n.hub-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n  border-radius: var(--radius-full);\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);\n  &--sm { width: 22px; height: 22px; font-size: 0.62rem; }\n}\n\n/* Neutral tag pill — kept quiet so the primary (emerald) actions lead the hierarchy */\n.hub-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: var(--muted-foreground);\n  background: var(--secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  transition: color var(--transition), background var(--transition);\n  &--more { opacity: 0.75; }\n}\n\n/* Task-type pill — icon + text share one hue per type for instant, coherent color-coding */\n.hub-type-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.18rem 0.6rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border-radius: var(--radius-full);\n  border: 1px solid transparent;\n  white-space: nowrap;\n\n  i { font-size: 0.68rem; }\n\n  /* classification → emerald */\n  &--classification {\n    color: var(--brand-600);\n    background: rgba(16, 185, 129, 0.12);\n    border-color: rgba(16, 185, 129, 0.28);\n  }\n  /* detection → sky blue */\n  &--bounding_box {\n    color: #0284c7;\n    background: rgba(56, 189, 248, 0.14);\n    border-color: rgba(56, 189, 248, 0.30);\n  }\n  /* segmentation → violet */\n  &--segmentation {\n    color: #7c3aed;\n    background: rgba(167, 139, 250, 0.16);\n    border-color: rgba(167, 139, 250, 0.32);\n  }\n}\nhtml.dark .hub-type-pill--classification { color: var(--brand-300); }\nhtml.dark .hub-type-pill--bounding_box { color: #7dd3fc; }\nhtml.dark .hub-type-pill--segmentation { color: #c4b5fd; }\n\n/* ---------- Drawer (portalled to body — outside .public-model-hub) ---------- */\n.hub-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1080;\n  background: var(--overlay);\n  backdrop-filter: blur(2px);\n  display: flex;\n  justify-content: flex-end;\n  animation: hub-fade 0.18s ease-out;\n}\n\n.hub-drawer {\n  width: min(480px, 100%);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--card);\n  border-left: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n  animation: hub-slide-in 0.24s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 1.15rem 1.25rem;\n    border-bottom: 1px solid var(--border);\n  }\n  &__heading {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    min-width: 0;\n  }\n  &__subrow {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  &__title {\n    margin: 0;\n    font-size: 1.15rem;\n    font-weight: 600;\n    color: var(--foreground);\n    letter-spacing: -0.01em;\n    word-break: break-word;\n  }\n  &__primary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.45rem;\n    width: 100%;\n    margin: 1.1rem 0 0.25rem;\n    padding: 0.65rem 1rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--primary-foreground);\n    background: var(--primary);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: background var(--transition), box-shadow var(--transition);\n    &:hover { background: var(--primary-hover); box-shadow: var(--shadow-glow); }\n    &:disabled { opacity: 0.65; cursor: default; box-shadow: none; }\n  }\n  &__close {\n    margin-left: auto;\n    width: 34px;\n    height: 34px;\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-full);\n    background: transparent;\n    color: var(--muted-foreground);\n    cursor: pointer;\n    transition: background var(--transition), color var(--transition);\n    &:hover { background: var(--secondary); color: var(--foreground); }\n  }\n\n  &__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1.25rem;\n  }\n  &__detail {\n    margin: 0 0 1rem;\n    font-size: 0.9rem;\n    line-height: 1.55;\n    color: var(--muted-foreground);\n  }\n\n  &__facts {\n    display: flex;\n    flex-direction: column;\n    gap: 0.1rem;\n    margin: 1rem 0 1.5rem;\n    padding: 0.85rem 1rem;\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    background: var(--page-bg-subtle);\n  }\n\n  &__section-title {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0 0 0.75rem;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: var(--muted-foreground);\n  }\n  &__section-count {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 1.25rem;\n    height: 1.25rem;\n    padding: 0 0.35rem;\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: var(--muted-foreground);\n    background: var(--secondary);\n    border-radius: var(--radius-full);\n    letter-spacing: 0;\n  }\n  &__empty { color: var(--muted-foreground); font-size: 0.9rem; }\n}\n\n.hub-metric {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.35rem 0;\n  font-size: 0.85rem;\n  & + & { border-top: 1px solid var(--border); }\n  &__label { color: var(--muted-foreground); flex-shrink: 0; }\n  &__value { color: var(--foreground); font-weight: 500; text-align: right; word-break: break-word; }\n}\n.hub-owner-val {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n.hub-id-val {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  code { overflow: hidden; text-overflow: ellipsis; }\n}\n.hub-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: var(--secondary);\n  color: var(--muted-foreground);\n  cursor: pointer;\n  font-size: 0.72rem;\n  transition: background var(--transition), color var(--transition);\n  &:hover { background: var(--secondary-hover); color: var(--foreground); }\n}\n\n.hub-mono {\n  font-family: var(--font-mono);\n  font-size: 0.78rem;\n  color: var(--foreground);\n}\n\n.hub-version-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.hub-version {\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: var(--card-hover);\n\n  &__head {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    flex-wrap: wrap;\n  }\n  &__name {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: var(--foreground);\n    i { color: var(--muted-foreground); font-size: 0.8rem; }\n  }\n  &__download {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin-left: auto;\n    padding: 0.35rem 0.75rem;\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: var(--primary-foreground);\n    background: var(--primary);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: background var(--transition);\n    &:hover { background: var(--primary-hover); }\n    &:disabled { opacity: 0.65; cursor: default; }\n  }\n\n  &__classes {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin-top: 0.65rem;\n  }\n  &__metrics {\n    margin-top: 0.65rem;\n    padding-top: 0.5rem;\n    border-top: 1px solid var(--border);\n  }\n}\n\n.hub-class-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.2rem 0.55rem;\n  font-size: 0.75rem;\n  color: var(--foreground);\n  background: var(--secondary);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n\n  &__dot {\n    width: 9px;\n    height: 9px;\n    border-radius: var(--radius-full);\n    background: var(--muted-foreground);\n    flex-shrink: 0;\n  }\n}\n\n/* ---------- Toolbar dropdown menu ----------\n   Portalled to <body>, so these rules live at the top level on purpose —\n   nesting them under .public-model-hub would mean they never match. */\n.hub-dropdown-portal {\n  /* A long owner display name would otherwise stretch the menu to its width;\n     cap it and let the label ellipsis instead. min-width (set inline from the\n     trigger) still wins, so a narrow trigger is unaffected. */\n  max-width: min(360px, calc(100vw - 20px));\n\n  .hub-dropdown__menu {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    overflow: hidden;\n  }\n\n  .hub-dropdown__search {\n    display: flex;\n    align-items: center;\n    gap: 0.45rem;\n    padding: 0.5rem 0.65rem;\n    border-bottom: 1px solid var(--border);\n    background: var(--page-bg-subtle);\n\n    i { font-size: 0.75rem; color: var(--muted-foreground); flex-shrink: 0; }\n\n    input {\n      flex: 1;\n      min-width: 0;\n      font-size: 0.82rem;\n      color: var(--foreground);\n      background: transparent;\n      border: none;\n      outline: none;\n      &::placeholder { color: var(--muted-foreground); }\n    }\n  }\n\n  /* The scroll container. Its own scroll must not close the menu — see HubDropdown. */\n  .hub-dropdown__list {\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding: 0.3rem 0;\n    outline: none;\n  }\n\n  .hub-dropdown__item {\n    gap: 0.5rem;\n    padding: 0.45rem 0.7rem;\n\n    &.is-focused { background: var(--muted); }\n    &.is-active { color: var(--primary); font-weight: 600; }\n  }\n\n  .hub-dropdown__tick {\n    width: 1rem;\n    flex-shrink: 0;\n    font-size: 0.72rem;\n    opacity: 0;\n    &.is-on { opacity: 1; color: var(--primary); }\n  }\n\n  .hub-dropdown__dot {\n    width: 9px;\n    height: 9px;\n    flex-shrink: 0;\n    border-radius: var(--radius-full);\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);\n  }\n\n  .hub-dropdown__item-label {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .hub-dropdown__count {\n    flex-shrink: 0;\n    padding: 0.05rem 0.4rem;\n    font-family: var(--font-mono);\n    font-size: 0.7rem;\n    font-weight: 500;\n    color: var(--muted-foreground);\n    background: var(--secondary);\n    border-radius: var(--radius-full);\n  }\n\n  .hub-dropdown__none {\n    margin: 0;\n    padding: 0.85rem 0.7rem;\n    font-size: 0.8rem;\n    text-align: center;\n    color: var(--muted-foreground);\n  }\n}\n\n/* Selected item in the toolbar dropdown */\n.labelflow-dropdown-item.is-active {\n  color: var(--primary);\n  font-weight: 600;\n}\n\n@keyframes hub-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n@keyframes hub-slide-in {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n@media (max-width: 640px) {\n  .public-model-hub {\n    padding: 0.85rem;\n    .hub-toolbar { position: static; }\n    .hub-toolbar__meta { margin-left: 0; width: 100%; }\n  }\n  .hub-drawer { width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
